var App = App || {};

App.LandingMasthead = (() => {
    'use strict';

    const init = (id) => {
        const masthead = document.getElementById(id);
        const mastheadSection = masthead.closest('.section');

        if (mastheadSection) {
            window.addEventListener('scroll', () => {
                const rect = mastheadSection.getBoundingClientRect();
                const mastheadBottom = rect.bottom; // Distance from the top of the viewport to the bottom of the element
                const viewportHeight = window.innerHeight; // Height of the visible viewport

                if (mastheadBottom <= viewportHeight) {
                    mastheadSection.classList.add('position-sticky');

                    if (mastheadSection.style.top === '') {
                        mastheadSection.style.top = `${rect.top}px`;
                    }
                    mastheadSection.style.zIndex = '-1';
                }
                else {
                    mastheadSection.classList.remove('position-sticky');
                    mastheadSection.style.top = '';
                    mastheadSection.style.zIndex = '';
                }
            });
        }
    };

    return { init };
})();